var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{staticClass:"img",attrs:{"src":require("../../../assets/tab-icon/list/hot-mini.png")}}),_c('button',{staticClass:"btn",on:{"click":_vm.openMini}}),_c('page-wrap',{attrs:{"title":"5.16新政热门问题答疑"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }